import axios from 'axios'
import CONFIG from '@/config/config'
const PRE_FIX = CONFIG.API_URL// + (CONFIG.PROFILE === 'production' ? '/api':'')
import Vue from 'vue'

let checkParams = function(params) {
    let checkObj = $.extend(true,{},params)
    let checkedKeys = Object.keys(checkObj).filter(key => key !== 'page' && !checkObj[key])
    checkedKeys.forEach(function(key) {
        delete checkObj[key]
    })
    return  checkObj
}

export default {
    async getClientCodeList(onlyUse) {
        return await axios.get(PRE_FIX + '/v1/ums/code/list?onlyUse='+onlyUse).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async getSenderList(onlyUse) {
        return await axios.get(PRE_FIX + '/v2/ums/code/list?codeType=1&onlyUse='+onlyUse).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async saveClientCode(params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/code/save',checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function(){
            Vue.prototype.$loading(false)
        })
    },
    async saveSenderCode(params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v2/ums/code/save',checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function(){
            Vue.prototype.$loading(false)
        })
    },
    async getUserList() {
        return await axios.get(PRE_FIX + '/v1/ums/user/list').catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async userSave(params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/user/save',checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function(){
            Vue.prototype.$loading(false)
        })
    },
    async loginUser(params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/user/login',checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function(){
            Vue.prototype.$loading(false)
        })
    },
    async getProfile() {
        return await axios.get(PRE_FIX + '/v1/ums/profiles').catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async getStats(params) {
        console.log('getStats params: ', params);
        return await axios.post(PRE_FIX + '/v1/ums/stats',params).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function(){
            Vue.prototype.$loading(false);
        })
    }

}
